
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiComputerPc as ObiComputerPcElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-computer-pc.js';
 
 
 

 
 export const ObiComputerPc = createComponent({
   react: React,
   tagName: 'obi-computer-pc',
   elementClass: ObiComputerPcElement,
   events: {
     
   }
  });
 
 